/**
 * Read JWT exp (seconds since epoch) from an HS512 bearer token without verifying the signature.
 * Used only for client-side session warning timing.
 */
function base64UrlToUtf8(segment) {
  const base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
  const pad = base64.length % 4
  const padded = pad ? base64 + '='.repeat(4 - pad) : base64
  try {
    const binary = atob(padded)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i)
    }
    return new TextDecoder().decode(bytes)
  } catch {
    return null
  }
}

export function getJwtExpiryUnix(token) {
  if (!token || typeof token !== 'string') return null
  const parts = token.split('.')
  if (parts.length < 2) return null
  const json = base64UrlToUtf8(parts[1])
  if (!json) return null
  try {
    const payload = JSON.parse(json)
    return typeof payload.exp === 'number' ? payload.exp : null
  } catch {
    return null
  }
}

export function getSecondsUntilJwtExpiry(token) {
  const exp = getJwtExpiryUnix(token)
  if (exp == null) return null
  return exp - Math.floor(Date.now() / 1000)
}

// Default export for dot-index-webpack-plugin (`export { default as jwtExpiry } from './jwt-expiry'`).
export default {
  getJwtExpiryUnix,
  getSecondsUntilJwtExpiry,
}
